/* 集中 feature flag（生产站无开关框架，沿用 REACT_APP_* 环境变量约定）。
   新 Omniversail 营销页（首页 /、课程 /curriculum、竞赛 /comps）以此灰度：
   - 默认开启；
   - 设 REACT_APP_OMNIVERSAIL_NEW_PAGES=false 即整体回退旧 LandingPage，
     便于出问题时一键回滚而不改代码。 */
export const OMNIVERSAIL_NEW_PAGES =
  process.env.REACT_APP_OMNIVERSAIL_NEW_PAGES !== 'false';

/* 手机号（短信验证码）登录 / 注册入口开关。
   暂时下线：默认隐藏登录页与注册页上的手机号入口（"or use phone" 分隔线 +
   PhoneAuthPanel 整体不渲染）。
   需要恢复时设 REACT_APP_PHONE_AUTH_ENABLED=true 即可，无需改代码。 */
export const PHONE_AUTH_ENABLED =
  process.env.REACT_APP_PHONE_AUTH_ENABLED === 'true';

export default { OMNIVERSAIL_NEW_PAGES, PHONE_AUTH_ENABLED };
